import React from 'react';

function AgentConversation() {
  return (
    <div className="agent">
      <div className="agent__header">
        <span className="agent__avatar" aria-hidden="true">DA</span>
        <span className="agent__title">Decode Agent</span>
      </div>

      <div className="agent__msg agent__msg--user">
        <div className="agent__bubble agent__bubble--user">
          <p>
            Decode, run the earned-to-incurred analysis across all contracts under syndicate
            Aldmere. Find the policies dragging the loss ratio, and email the report to Chris.
          </p>
        </div>
        <span className="agent__avatar agent__avatar--user" aria-hidden="true">UW</span>
      </div>

      <div className="agent__msg">
        <span className="agent__avatar" aria-hidden="true">DA</span>
        <div className="agent__bubble agent__bubble--agent">
          <p>
            No problem. Let me figure out which contracts you have under Aldmere, then run the
            analysis.
          </p>
          <div className="agent__stats">
            <strong>3</strong> functions run &middot; <strong>2</strong> files produced &middot;{' '}
            <strong>1</strong> email sent &middot; <strong>14</strong> minutes
          </div>
          <p>
            Done. Contracts A201 and A202 are above 0.8 NLR. The report breaks the underperforming
            policies down by contract and region, and it&rsquo;s with Chris.{' '}
            <strong>Worth flagging: A202 has climbed three months running.</strong>
          </p>
          <div className="agent__files">
            <span className="agent__file">
              <span className="agent__file-glyph agent__file-glyph--sheet" aria-hidden="true">X</span>
              EarnedIncurredAldmere.xlsx
            </span>
            <span className="agent__file">
              <span className="agent__file-glyph agent__file-glyph--doc" aria-hidden="true">W</span>
              NLRAnalysisReport.docx
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentConversation;
